var _polygon, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorluulalt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.69,
    y: 140.98,
    width: 164.14,
    height: 242.17,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.42,
    y: 140.98,
    width: 17.41,
    height: 242.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 146.58,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 176.57,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 206.56,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 236.55,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 266.55,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 296.54,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 326.53,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 356.52,
    width: 136.79,
    height: 24.6,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.43,
    y: 104.43,
    width: 106.83,
    height: 141.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.33,
    y: 123.53,
    width: 137.02,
    height: 102.83,
    transform: "translate(307.79 42.1) rotate(90)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.22 130.64 131.13 113.96 141.93 126.09 154.56 118.97 152.5 133.26 170.47 141.62 157.55 148.24 166.48 168.66 146.83 166.81 143.53 184.43 131.13 170.06 117.83 178.2 119.04 161.49 106.56 157.98 121.39 145.04 110.78 127.67 126.22 130.64",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.05 205.18 105.15 194.65 111.96 202.31 119.94 197.81 118.63 206.84 129.98 212.11 121.82 216.29 127.46 229.19 115.05 228.02 112.97 239.14 105.15 230.07 96.74 235.21 97.51 224.66 89.63 222.44 98.99 214.27 92.29 203.31 102.05 205.18",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.05 203.54 173.44 204.98 169.15 209.33 172.13 213.9 166.71 213.47 164.01 220.43 161.21 215.73 153.76 219.59 153.98 212.16 147.28 211.35 152.37 206.35 148.99 201.55 155.3 201.6 156.31 196.83 161.53 202.08 167.79 197.67 167.05 203.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.23,145.72c-.85-3.81.87-6.73,3.75-7.37s5.48,1.22,6.29,4.86c.84,3.81-.67,6.72-3.75,7.4S124,149.36,123.23,145.72Zm2.65-.59c.56,2.55,1.81,3.32,3.13,3s2.25-1.61,1.64-4.36c-.55-2.51-2-3.32-3.17-3S125.28,142.41,125.88,145.13Zm8.4,16.48-3.44.76,8.76-26.67,3.44-.76Zm7-8c-.85-3.81.87-6.72,3.75-7.36s5.48,1.22,6.29,4.86c.84,3.81-.67,6.72-3.75,7.4S142.12,157.31,141.32,153.66Zm2.64-.58c.57,2.55,1.82,3.31,3.14,3s2.25-1.61,1.64-4.36c-.56-2.52-2-3.32-3.18-3.05S143.36,150.36,144,153.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.47,210.63c.8-2.41,2.74-3.46,4.56-2.85s2.65,2.52,1.88,4.82-2.62,3.53-4.57,2.87S100.69,212.93,101.47,210.63Zm1.67.56c-.54,1.61-.1,2.46.74,2.74s1.79-.14,2.38-1.88,0-2.51-.76-2.77S103.72,209.48,103.14,211.19Zm-.83,12-2.18-.73L114,210.53l2.18.73Zm6.59-2.08c.8-2.41,2.74-3.46,4.56-2.85s2.65,2.52,1.88,4.82-2.63,3.52-4.57,2.87S108.12,223.43,108.9,221.13Zm1.67.56c-.54,1.61-.1,2.46.74,2.74s1.79-.14,2.37-1.88,0-2.51-.75-2.77S111.15,220,110.57,221.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23,206.24a1.68,1.68,0,0,1,1.57-1.88c.87,0,1.49.71,1.49,1.81s-.63,1.89-1.56,1.89S156.23,207.34,156.23,206.24Zm.81,0c0,.77.3,1.07.7,1.07s.75-.31.76-1.14-.35-1.08-.72-1.09S157,205.42,157,206.24Zm1.34,5.29h-1l4.27-7.09h1Zm2.54-1.83a1.66,1.66,0,0,1,1.56-1.87,1.59,1.59,0,0,1,1.49,1.81c0,1.15-.63,1.89-1.56,1.88S160.91,210.81,160.92,209.7Zm.8,0c0,.77.3,1.07.7,1.07s.75-.31.76-1.14-.34-1.08-.72-1.09S161.72,208.89,161.72,209.71Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "295.99 403 302.29 404.11 304.88 395.51 307.24 387.62 299.97 385.08 297.86 394.57 295.99 403",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.82 394.76 304.85 395.69 307.23 387.71 299.96 385.12 297.82 394.76",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.1 405.91 344.5 405.91 345.55 396.88 346.51 388.65 338.9 387.39 338.47 397.19 338.1 405.91",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.47 397.27 345.55 396.96 346.51 388.69 338.9 387.41 338.47 397.27",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.42,418.59a10.73,10.73,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27a4.15,4.15,0,0,1,4.43,1.73,2.7,2.7,0,0,1,.31.64,29.61,29.61,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2h-.88l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C330.5,420.48,327.74,420.22,329.42,418.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.92,417.84a10.73,10.73,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.27a4.15,4.15,0,0,1,4.43,1.73,2.7,2.7,0,0,1,.31.64,29.61,29.61,0,0,1,.52,3.61c.49,3.76.07,12.2.07,12.2h-.88l-.35-7.66c-.13-2.6-2.12.45-2.69,3.25s-1.78,5.78-7.48,5.92C288,419.73,285.24,419.47,286.92,417.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.23,389.76l10.37,1.82c10.46-26.07,17.9-47.83,23.16-65.89,2.83-9.74,5.19-18.4,6.89-26.09L337.33,328v63.93h10.22C373.17,269.91,355,242.1,355,242.1L324.37,237a138.5,138.5,0,0,0-2.57,17.22l-1.38,10.16-12,61.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.23,389.76l10.37,1.82c10.46-26.07,17.9-47.83,23.16-65.89,2.83-9.74,5.19-18.4,6.89-26.09L337.33,328v63.93h10.22C373.17,269.91,355,242.1,355,242.1L324.37,237a138.5,138.5,0,0,0-2.57,17.22l-1.38,10.16-12,61.87Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M330.76,325.69c2.83-9.74,5-18.4,6.73-26.09a240.2,240.2,0,0,0-2-27.22S331,307.48,330.76,325.69Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.43,151.12s7.11-6.74,13.24,1.77S365,171.48,365.2,178.6s3.39,6.33,3.39,6.33-5,5.59-9.62,0-.51-17.41-1.44-21.77S354.43,151.12,354.43,151.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.78,219.6l-11.36,4.27s-2.21-.69-3.13-.2-5.37,5-5.24,5.83,4.06,3.78,5.28,3.23,4.5-5,4.64-5.52l13.74-4.76Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,188.25c-3.61,1.92-20.08,21.21-21.79,22.39-3,2.09-20.56,10.91-20.56,10.91l2,4.59s12.72-4.65,20.28-7.12c6.4-2.09,21-15.79,21-15.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,208.46c3-2.86,5.14-5.22,5.14-5.22l-.23-3.56L325,196.23A14.2,14.2,0,0,0,321.19,208.46Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.1,204.65c-1.2,3.87-2.14,7.21-2.89,10.2a110.85,110.85,0,0,0-3.32,23l-31.26-2.7c-1.25-22-.69-34.12-.12-40.17.62-6.45,1.62-6.69,1.62-6.69s7-.68,13.06-.63a98.6,98.6,0,0,1,14,1.48,93.49,93.49,0,0,1,13,3.13c-.71,2-1.35,4-1.95,5.76C362.45,200.37,361.74,202.59,361.1,204.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.55,189a7.12,7.12,0,0,1,.95-.41c.72-.57,1.6-1.94,1.55-5.27a25.82,25.82,0,0,0-.36-3.91l9.27-1.73s-3.16,6.24-.52,10.88c.91.4,1.54,1,1.35,1.72-.83,3.29-10.66,7.26-10.66,7.26S333,192,338.55,189Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.69,179.37a25.82,25.82,0,0,1,.36,3.91c6.27,0,8.91-5.64,8.91-5.64Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.83,148.78S334,147.41,332,156.16a13.47,13.47,0,0,0,4.75,13.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.82,153.45c-8.06-.44-10.89,3.73-11.94,12-1.3,10.34.59,17.84,10.79,16.18C358.52,179.37,359.2,154.18,345.82,153.45Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12,165.29a17,17,0,0,1-2.53,3.21,2.21,2.21,0,0,0,2.07,1Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.09,164.9c-.06.66.26,1.22.7,1.26s.84-.47.89-1.14-.26-1.22-.7-1.26S344.14,164.24,344.09,164.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.16,163.81l-1.39-.68S344.39,164.4,345.16,163.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.88,164.12c-.05.66.26,1.22.7,1.26s.84-.48.89-1.14-.26-1.22-.7-1.26S335.93,163.46,335.88,164.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,163l-1.39-.68S336.18,163.62,337,163Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.47,159.34a4.21,4.21,0,0,1,3.43,1.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.63,158.68a3.76,3.76,0,0,0-3.25.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.88,167.51s-3.4-6.82-2.55-11.91c0,0-15.62-7.4-17.29,8.77,0,0-.78-14.48,13.1-14s12.7,20.71,5.22,26.35C352.36,176.68,356,171.78,353.88,167.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.46,148.16s-4.58-.37-6.45,1.38,9.45,12.87,16.45,14.12c0,0,2.37,7.75.5,11.37,0,0,7.87-2.75,8.25-14.75S350,143.78,343.46,148.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.47,169.14a3.56,3.56,0,0,1,4-3c2.48.41,3.39,5.6-2.89,6.5C352.67,172.74,352.21,171.85,352.47,169.14Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.68,150.15s2.4,10,11.78,13.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,171.41a6.49,6.49,0,0,1-4.63,1.87",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.686238px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.36,156.22s5.85,4.06,5.19,8.74a12.68,12.68,0,0,0-7.12-6.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,152.18l6.1-7.68a2.93,2.93,0,0,1,2.52-1.1,62.32,62.32,0,0,1,11,1.71,4.2,4.2,0,0,1,3,3.65l.92,10.1L352.28,157Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,152.18l6.1-7.68a2.93,2.93,0,0,1,2.52-1.1,62.32,62.32,0,0,1,11,1.71,4.2,4.2,0,0,1,3,3.65l.92,10.1L352.28,157Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.89,153.37s21.65,5.14,32.64,5.49c0,0-3.41-5-11.08-7.31C341.28,150,331.34,148.66,324.89,153.37Z",
    style: {
      fill: "#407BFF"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "354.89 237.81 323.63 235.11 323.63 240.46 355.63 243.29 354.89 237.81"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,237.47V240a1.93,1.93,0,0,0,1.77,1.93l3.9.35h.17a1.94,1.94,0,0,0,1.31-.51,1.92,1.92,0,0,0,.63-1.43v-2.49a1.93,1.93,0,0,0-1.77-1.93l-3.91-.34a1.92,1.92,0,0,0-1.47.5A2,2,0,0,0,332.35,237.47Zm1,2.49v-.82l0,0,1.09.08a.66.66,0,1,0,.1-1.32l-1.09-.09-.15,0v-.38a.94.94,0,0,1,.93-.94h.09l3.9.33a1,1,0,0,1,.86.94v2.49a1,1,0,0,1-.3.7,1,1,0,0,1-.72.24l-3.91-.35A.93.93,0,0,1,333.35,240Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.74,228.48l-10.8-6.81s-.82-2.28-1.83-2.75-7.57-1.33-8.21-.67-.58,5.8.66,6.47,7,.6,7.57.38l12.11,9.27Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.11,192.24s-7.06,10.25-6,19l9.36,15.52-6.29-3.22L359.29,229s7.25,11.15,16.47,8.52S365.11,192.24,365.11,192.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.81 223.27 359.22 229.93 358.42 228.03 361.27 222.62 362.81 223.27",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.25 226.77 283.01 220.57 281.88 221.89 284.06 226.77 286.25 226.77",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.67,186.55s-3.49,7.36-9,9.68c0,0-.1-7.3,1.06-9.68l-3.21,1.07s-6.35,3-8.24,8.61c0,0,7.55-2.17,7.71-1.77s2.17,8.57,2.17,8.57l6.21-7.65,7.07,7s2.71-7.76,1.87-12.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 206.27,
    width: 5.52,
    height: 9.02,
    rx: 0.79,
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.33,
    y: 207.71,
    width: 4.48,
    height: 5.29,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.17,
    y: 204.1,
    width: 0.99,
    height: 2.89,
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.22,252.37v14.68H270.51V252.37a2.11,2.11,0,0,1,2.11-2.11h24.49A2.12,2.12,0,0,1,299.22,252.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.22,252.37v14.68H270.51V252.37a2.11,2.11,0,0,1,2.11-2.11h24.49A2.12,2.12,0,0,1,299.22,252.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.22,252.37v14.68H270.51V252.37a2.11,2.11,0,0,1,2.11-2.11h17.49A2.12,2.12,0,0,1,292.22,252.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.91,
    y: 207.83,
    width: 2.62,
    height: 13.49,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.53 221.32 202.91 221.32 202.91 212.83 205.53 213.83 205.53 221.32",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.16,
    y: 199.36,
    width: 45.28,
    height: 11.45,
    transform: "translate(407.6 410.17) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.16,
    y: 199.36,
    width: 45.28,
    height: 11.45,
    transform: "translate(407.6 410.17) rotate(180)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.75 251.57 230.78 219.08 187.21 219.08 179.06 219.08 179.06 267.58 261.47 267.58 261.47 258.22 239.75 251.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.75 251.57 230.78 219.08 187.21 219.08 179.06 219.08 179.06 267.58 261.47 267.58 261.47 258.22 239.75 251.57",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.75 251.57 196.18 251.57 187.21 219.08 230.78 219.08 239.75 251.57",
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.36 246.93 199.01 246.93 192.6 223.72 227.95 223.72 234.36 246.93",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.18 251.57 222.7 258.22 222.7 268.59 179.06 268.59 179.06 219.08 187.21 219.08 196.18 251.57",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.7,
    y: 258.22,
    width: 38.77,
    height: 9.36,
    style: {
      fill: "#fff",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.34,
    y: 200.35,
    width: 40.28,
    height: 9.47,
    transform: "translate(410.96 410.17) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.16,
    y: 199.36,
    width: 2.9,
    height: 11.45,
    transform: "translate(405.22 410.17) rotate(180)",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.32,
    y: 268.59,
    width: 295.26,
    height: 151.79,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.32,
    y: 268.59,
    width: 242.11,
    height: 151.79,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.32,
    y: 268.59,
    width: 295.26,
    height: 151.79,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.62,271H100.26a2.58,2.58,0,0,1-2.58-2.57h0a2.58,2.58,0,0,1,2.58-2.58H401.62a2.58,2.58,0,0,1,2.58,2.58h0A2.58,2.58,0,0,1,401.62,271Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--trash-bin--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418,399.12a2.55,2.55,0,0,0-2-3.66,5.47,5.47,0,0,0-1.73-6,1.23,1.23,0,0,0-.75-.34,1.45,1.45,0,0,0-.81.36l-4.78,3.43a3,3,0,0,0-.95.94c-1,1.89,2.55,4.32,1.1,5.88-.42.45-1.09.54-1.61.87-1.13.71-1.27,2.27-1.8,3.51s-2.38,2.18-3.09,1c.52-1.18-1.06-2.2-2.34-2.35s-2.62-.22-3.33-1.42c-1.82,1.59-5.9-2.85-5.81-4.64a3.48,3.48,0,0,0-2.84,2.92,21.39,21.39,0,0,0-.16,4.46c0,2.9-1,5.74-.93,8.64,0,2.26.91,4.76,3,5.67a7.67,7.67,0,0,0,3.2.43l23.53-.15a3.55,3.55,0,0,0,1.65-.28c1.06-.55,1.29-1.94,1.39-3.14L420.15,400Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,399.12a2.55,2.55,0,0,0-2-3.66,5.47,5.47,0,0,0-1.73-6,1.23,1.23,0,0,0-.75-.34,1.45,1.45,0,0,0-.81.36l-4.78,3.43a3,3,0,0,0-.95.94c-1,1.89,2.55,4.32,1.1,5.88-.42.45-1.09.54-1.61.87-1.13.71-1.27,2.27-1.8,3.51s-2.38,2.18-3.09,1c.52-1.18-1.06-2.2-2.34-2.35s-2.62-.22-3.33-1.42c-1.82,1.59-5.9-2.85-5.81-4.64a3.48,3.48,0,0,0-2.84,2.92,21.39,21.39,0,0,0-.16,4.46c0,2.9-1,5.74-.93,8.64,0,2.26.91,4.76,3,5.67a7.67,7.67,0,0,0,3.2.43l23.53-.15a3.55,3.55,0,0,0,1.65-.28c1.06-.55,1.29-1.94,1.39-3.14L420.15,400Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.39,374.26h-36.5l.3,3.68.22,2.64.55,6.85.32,3.94.42,5.24.18,2.24.06.67.22,2.64.29,3.62.18,2.25.19,2.28L386,413l.16,2,.18,2.25.08,1H420l.08-1,.18-2.24.16-2,.22-2.64.18-2.27.18-2.25.3-3.62.21-2.64.05-.67.18-2.24.43-5.24.32-3.93.55-6.86.21-2.64.3-3.68Zm2.2,2.42h0l-.7-.71h.76Zm-.18,2.23-.07.9-3.27,3.26-3.75-3.74,3.36-3.36h.79Zm-.94,11.68-2.4,2.4-3.75-3.75,3.75-3.74,2.59,2.59Zm-34.74-2.5h0l2.59-2.59,3.75,3.74L388.32,393l-2.38-2.4Zm31.13-3.81L413.12,388l-3.75-3.75,3.75-3.75ZM411,376h4.29l-2.14,2.15Zm.93,13.27L408.16,393l-3.75-3.75,3.75-3.74Zm-12.45,5,3.75-3.74,3.74,3.74-3.74,3.74Zm2.53,4.95-3.74,3.75-3.74-3.74,3.74-3.75Zm6.18-3.74,3.74,3.75-3.74,3.74-3.75-3.75Zm-5-7.38-3.75-3.75,3.75-3.75,3.74,3.75ZM402,389.24,398.24,393l-3.74-3.75,3.74-3.74Zm-8.7-1.21-3.74-3.75,3.74-3.75,3.75,3.75Zm0,2.43L397,394.2l-3.75,3.74-3.74-3.74ZM397,404.12l-3.75,3.74-3.74-3.74,3.74-3.75Zm1.21,1.21,3.74,3.75-3.74,3.74-3.74-3.74Zm1.21-1.21,3.75-3.75,3.74,3.75-3.74,3.74Zm8.71,1.21,3.74,3.75-3.74,3.74-3.75-3.74Zm5,5,3.74,3.74-2.42,2.43h-2.65L409.37,414Zm-3.75-6.17,3.75-3.75,3.74,3.75-3.74,3.74Zm0-9.92,3.75-3.74,3.74,3.74-3.74,3.74Zm2.53-14.87-3.74,3.74-3.75-3.74,3.35-3.36h.79Zm-8.7-1.21L401.06,376h4.28ZM402,379.33l-3.74,3.74-3.74-3.74,3.35-3.36h.79ZM395.42,376l-2.14,2.15L391.14,376Zm-6.7,0,3.35,3.36-3.75,3.74-3.26-3.26-.07-.9,2.94-2.94Zm-3.21,0-.7.7h0l-.06-.7Zm-.23,6.48,1.83,1.83-1.56,1.56Zm1,12.56-.15-1.77h0l1,1-.81.81Zm.18,2.26,1.84-1.86,3.75,3.75-3.75,3.74-1.51-1.51Zm.55,6.93V404l.08.09-.08.08Zm.66,8-.48-5.74,1.11-1.11,3.75,3.75-3.75,3.74-.63-.64Zm.34,4.28-.07-.86.36-.36,1.22,1.22Zm1.51-2.43,3.74-3.74L397,414l-2.43,2.43H392Zm7.49,2.43,1.21-1.22,1.22,1.22Zm4.85,0L399.45,414l3.75-3.74,3.74,3.74-2.42,2.43Zm5.06,0,1.22-1.22,1.22,1.22Zm11.42,0h-1.51l1.22-1.22.36.36Zm.36-4.28-.65.64-3.75-3.74,3.75-3.75,1.11,1.11Zm.66-8.15,0,.17-.08-.08.1-.09Zm.21-2.64-1.52,1.51-3.75-3.74,3.75-3.75,1.85,1.86Zm.51-6.37-.82-.82,1-1Zm1-12.58-.28,3.41-1.57-1.57,1.85-1.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.39,374.26h-36.5l.3,3.68.22,2.64.55,6.85.32,3.94.42,5.24.18,2.24.06.67.22,2.64.29,3.62.18,2.25.19,2.28L386,413l.16,2,.18,2.25.08,1H420l.08-1,.18-2.24.16-2,.22-2.64.18-2.27.18-2.25.3-3.62.21-2.64.05-.67.18-2.24.43-5.24.32-3.93.55-6.86.21-2.64.3-3.68Zm2.2,2.42h0l-.7-.71h.76Zm-.18,2.23-.07.9-3.27,3.26-3.75-3.74,3.36-3.36h.79Zm-.94,11.68-2.4,2.4-3.75-3.75,3.75-3.74,2.59,2.59Zm-34.74-2.5h0l2.59-2.59,3.75,3.74L388.32,393l-2.38-2.4Zm31.13-3.81L413.12,388l-3.75-3.75,3.75-3.75ZM411,376h4.29l-2.14,2.15Zm.93,13.27L408.16,393l-3.75-3.75,3.75-3.74Zm-12.45,5,3.75-3.74,3.74,3.74-3.74,3.74Zm2.53,4.95-3.74,3.75-3.74-3.74,3.74-3.75Zm6.18-3.74,3.74,3.75-3.74,3.74-3.75-3.75Zm-5-7.38-3.75-3.75,3.75-3.75,3.74,3.75ZM402,389.24,398.24,393l-3.74-3.75,3.74-3.74Zm-8.7-1.21-3.74-3.75,3.74-3.75,3.75,3.75Zm0,2.43L397,394.2l-3.75,3.74-3.74-3.74ZM397,404.12l-3.75,3.74-3.74-3.74,3.74-3.75Zm1.21,1.21,3.74,3.75-3.74,3.74-3.74-3.74Zm1.21-1.21,3.75-3.75,3.74,3.75-3.74,3.74Zm8.71,1.21,3.74,3.75-3.74,3.74-3.75-3.74Zm5,5,3.74,3.74-2.42,2.43h-2.65L409.37,414Zm-3.75-6.17,3.75-3.75,3.74,3.75-3.74,3.74Zm0-9.92,3.75-3.74,3.74,3.74-3.74,3.74Zm2.53-14.87-3.74,3.74-3.75-3.74,3.35-3.36h.79Zm-8.7-1.21L401.06,376h4.28ZM402,379.33l-3.74,3.74-3.74-3.74,3.35-3.36h.79ZM395.42,376l-2.14,2.15L391.14,376Zm-6.7,0,3.35,3.36-3.75,3.74-3.26-3.26-.07-.9,2.94-2.94Zm-3.21,0-.7.7h0l-.06-.7Zm-.23,6.48,1.83,1.83-1.56,1.56Zm1,12.56-.15-1.77h0l1,1-.81.81Zm.18,2.26,1.84-1.86,3.75,3.75-3.75,3.74-1.51-1.51Zm.55,6.93V404l.08.09-.08.08Zm.66,8-.48-5.74,1.11-1.11,3.75,3.75-3.75,3.74-.63-.64Zm.34,4.28-.07-.86.36-.36,1.22,1.22Zm1.51-2.43,3.74-3.74L397,414l-2.43,2.43H392Zm7.49,2.43,1.21-1.22,1.22,1.22Zm4.85,0L399.45,414l3.75-3.74,3.74,3.74-2.42,2.43Zm5.06,0,1.22-1.22,1.22,1.22Zm11.42,0h-1.51l1.22-1.22.36.36Zm.36-4.28-.65.64-3.75-3.74,3.75-3.75,1.11,1.11Zm.66-8.15,0,.17-.08-.08.1-.09Zm.21-2.64-1.52,1.51-3.75-3.74,3.75-3.75,1.85,1.86Zm.51-6.37-.82-.82,1-1Zm1-12.58-.28,3.41-1.57-1.57,1.85-1.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 380.56,
    y: 372.73,
    width: 45.28,
    height: 4.77,
    rx: 1.64,
    transform: "translate(806.4 750.23) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.82,
    y: 415.61,
    width: 38.75,
    height: 4.77,
    rx: 1.64,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.2,194.33c-1.6,9.49,13.43,15.82,24.71,18.19s-14.27-16.81-14.27-16.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2,194.33c-1.6,9.49,13.43,15.82,24.71,18.19s-14.27-16.81-14.27-16.81Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.12,193.28a.82.82,0,0,0-.58-.34l-4.62-.51a.81.81,0,0,0-.89.65l-.94,4.72a.85.85,0,0,0,.14.64l5.24,7.17a.81.81,0,0,0,1.09.21l5.7-3.6a.81.81,0,0,0,.24-1.15Zm-4.63.93a.55.55,0,1,1,.2-.76A.55.55,0,0,1,168.49,194.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.12,193.28a.82.82,0,0,0-.58-.34l-4.62-.51a.81.81,0,0,0-.89.65l-.94,4.72a.85.85,0,0,0,.14.64l5.24,7.17a.81.81,0,0,0,1.09.21l5.7-3.6a.81.81,0,0,0,.24-1.15Zm-4.63.93a.55.55,0,1,1,.2-.76A.55.55,0,0,1,168.49,194.21Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.26,200.19a1.31,1.31,0,0,1,.32-1.9,1.25,1.25,0,0,1,1.74.63,1.3,1.3,0,0,1-.31,1.92A1.25,1.25,0,0,1,169.26,200.19Zm.55-.32c.31.53.64.61.92.46s.38-.52.05-1.09-.67-.6-.92-.46S169.48,199.31,169.81,199.87Zm3.05,3.08-.72.41.06-6.56.71-.42Zm1-2.27a1.32,1.32,0,0,1,.31-1.91,1.25,1.25,0,0,1,1.75.64,1.29,1.29,0,0,1-.31,1.91A1.25,1.25,0,0,1,173.86,200.68Zm.55-.32c.3.53.64.61.91.45s.39-.52.06-1.09-.67-.6-.93-.45S174.08,199.8,174.41,200.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.23,193.67s-3.1-5.94-8.55-2.71",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.37 194.33 143.31 185.06 165.58 189.69 165.58 209.75 124.16 219.45 111.68 215.69 113.37 194.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.58 209.75 144.07 204.54 111.68 215.69 124.16 219.45 165.58 209.75",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.31 185.06 144.07 204.54 165.58 209.75 165.58 189.69 143.31 185.06",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.87,204.54a25.26,25.26,0,0,0,2.07-1.87c.85-.9,10.05-.81,10.46.18s-1.33,5.51-2.86,6-8-.22-9.09-.87S149.87,204.54,149.87,204.54Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.87 204.54 143.31 209.82 145.68 212.52 151.94 206.72 149.87 204.54",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47,400.92l5.34.09c5.42-25.49,9.26-57,11.65-80.82.37-3.73.71-7.26,1-10.55.14-1.57.28-3.07.4-4.52.64-7.15,1.08-12.82,1.35-16.33.19-2.56.28-4,.28-4H107.21l.18,4.91L108,306l.06,1.86.41,10.71.67,18.24C102.51,362.44,106.47,400.92,106.47,400.92Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.19,399.56l5.26,1c10.52-26.3,20.4-60,26.82-83.49,1-3.65,1.91-7.06,2.73-10.15,0-.16.08-.31.12-.46,1.62-6.14,2.87-11,3.65-14.13.59-2.43.92-3.76.92-3.76l-19-3.29-1.08,8L81,305l-.31,2.31-1.07,8-2.89,21.47C65.85,361,63.19,399.56,63.19,399.56Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,305l17,1.9c0-.16.08-.31.12-.46,1.62-6.14,2.87-11,3.65-14.13l-19.17.95Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.39,289.74,108,306l.06,1.86,16.42,1.82c.14-1.57.28-3.07.4-4.52.64-7.15,1.08-12.82,1.35-16.33Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,418.64a10.35,10.35,0,0,0-3.34-1.82h0s-3.63-3.61-5.38-14.46l-4.76-1.24a4,4,0,0,0-4.33,1.69,2.37,2.37,0,0,0-.3.62,26.33,26.33,0,0,0-.51,3.53c-.48,3.67-.07,11.92-.07,11.92h.86l.34-7.48c.13-2.54,2.07.44,2.63,3.17s1.74,5.65,7.31,5.78C121.18,420.48,123.87,420.23,122.23,418.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.25,402.9c-.31-2.55-.41-7-.41-7l10.57,1.17s-1.27,5-.22,8.79C108.87,404.51,104.25,402.9,104.25,402.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.21,418.64a10.35,10.35,0,0,0-3.34-1.82h0s-3.63-3.61-5.38-14.46l-4.76-1.24a4.06,4.06,0,0,0-4.33,1.69,2.37,2.37,0,0,0-.3.62,26.33,26.33,0,0,0-.51,3.53c-.48,3.67-.07,11.92-.07,11.92h.86l.35-7.48c.12-2.54,2.07.44,2.62,3.17s1.74,5.65,7.31,5.78C78.16,420.48,80.86,420.23,79.21,418.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.24,402.9c-.32-2.55-.41-7-.41-7l10.57,1.17s-1.28,5-.23,8.79C65.85,404.51,61.24,402.9,61.24,402.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.43,176a2.07,2.07,0,0,0,.25.19,11.83,11.83,0,0,0,4.09,2c4.32,1,7.27.4,9.19-1.55h0c2.7-2.93,3.37-8.13,3-14.39a23.16,23.16,0,0,0-1.37-7.32s0-.09,0-.11-.06-.18-.1-.26a8.56,8.56,0,0,0-6.29-5.22,17.53,17.53,0,0,0-3.7-.42C85.27,148.75,83.07,169,92.43,176Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.68,176.14A11.35,11.35,0,0,0,96.77,178c4.32,1,7.27.27,9.19-1.72a12.17,12.17,0,0,1-7.75-.63C96.47,174.81,94.52,175.22,92.68,176.14Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.44,187.17c-.75,3.48,3.75,4.89,3.75,4.89,7.37-3.14,8.74-7.06,8.74-7.06-6.15-3.21-4.37-12.27-4.37-12.27l-1.25.61-8.77,1.72s2.43,4.67,2.75,5.74c0,0,0,0,0,0C94,186.4,91.44,187.17,91.44,187.17Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6,154.8s.67,8.57-7.44,12.25c0,0-3.49,8.89-8.62,9-7,.17-13.16-9.78-10.74-19.92C84,143,103.86,141.94,107.6,154.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.27,164.59c0-1.34-1.08-3.58-3.16-3.28s-3.34,5.62,1.94,6.8C103.81,168.28,104.27,167.38,104.27,164.59Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.68,145.7s8.17-2.07,12.69,1.22c5.28,3.84,7.28,7.81,1,14,0,0-13.72-4.45-18.28-3.51a49.12,49.12,0,0,0-7.82,2.27C79.34,150.59,88.12,143.85,92.68,145.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.93,146.09c-.51-1.21-1.56-3.87-4.64-2.4S93.92,142,92,142.5s-4,2.74-5.31,2.56a4.63,4.63,0,0,0-5.38,4.48c-.23,4.28-4,4.43-4.35,6.94s1.32,3.56,0,5.93-3.29,2.34-1.71,5.72,3.43,4.26,1.45,7.05-.53,5.43,2.37,6.62c0,0,3.83-3.83,5.67-2.24s5.84,3.67,7.6,1.24,4.87-1.51,5.56-.19,4-1.05,6.08-1.05,3.18,2.35,3.18,2.35,2.82-.77,2-5.11-2.79-16.5-1.45-19.92S103.93,146.09,103.93,146.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,186.33s-9.75-3.28-24.46.72-13.21,9.12-13.21,9.12,11.1,19.9,12.57,42.45l31.55-3.07S125.84,199.86,115.9,186.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,237.6h0l-.64-6.22-33.4,3.36.69,4.87h0c-12.58,22.27-9.53,47.68-9.53,47.68l-1.53,12.49s3.16,2,24.32,3.34c18.62,1.21,23.35-.72,23.35-.72C133.43,263.74,127.78,245.34,123.58,237.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.58,237.6h0l-.64-6.22-33.4,3.36.69,4.87h0c-12.58,22.27-9.53,47.68-9.53,47.68l-1.53,12.49s3.16,2,24.32,3.34c18.62,1.21,23.35-.72,23.35-.72C133.43,263.74,127.78,245.34,123.58,237.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.13 238.03 124.16 236.84 123.96 232.28 108.79 233.87 109.13 238.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.08 239.22 108.04 238.11 107.71 233.99 93.77 235.45 94.08 239.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.69 235.56 89.14 235.93 89.6 239.57 92.99 239.3 92.69 235.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,214.91a66.42,66.42,0,0,1-1.12,9.5s-22.1,6.39-37.83,3.34c0,0-3.2-25.25-5.92-33.42,0,0,5.63-6.27,10.44-6.71v-4.34s11.59-3.83,17.88-.88l-.59,2.6,14.46.06a124.55,124.55,0,0,1,2.48,17.1A101.06,101.06,0,0,1,121.07,214.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,214.91c-4.47-2.18-4.26-14.14-4.26-14.14l4.06,1.39A101.06,101.06,0,0,1,121.07,214.91Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.39,185.06c6.26,4.52,12.3,23.28,15.5,26.65s13-5.36,13-5.36l2.89,3.68s-12.42,15-19.4,10.41c-5.1-3.39-13.56-19.67-13.56-19.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,187.62a58.66,58.66,0,0,1,14.27-2.32S89.48,182.73,86.64,187.62Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trolley--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.29,302.61a2.28,2.28,0,0,1-1.27-.39l-23.8-15.73a2.65,2.65,0,0,0-1.5-.45H122.6l15.66,12.45a2.31,2.31,0,1,1-2.88,3.61l-20.83-16.56a2.31,2.31,0,0,1,1.44-4.12h50.73a7.3,7.3,0,0,1,4.05,1.22l23.79,15.73a2.31,2.31,0,0,1-1.27,4.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M193.29,302.61a2.28,2.28,0,0,1-1.27-.39l-23.8-15.73a2.65,2.65,0,0,0-1.5-.45H122.6l15.66,12.45a2.31,2.31,0,1,1-2.88,3.61l-20.83-16.56a2.31,2.31,0,0,1,1.44-4.12h50.73a7.3,7.3,0,0,1,4.05,1.22l23.79,15.73a2.31,2.31,0,0,1-1.27,4.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,297.21a1.08,1.08,0,0,0-.74-.54l-6.21-1.23a1.11,1.11,0,0,0-1.28.78l-1.83,6.31a1.1,1.1,0,0,0,.12.88l6.27,10.35a1.11,1.11,0,0,0,1.46.41l8.16-4.22a1.12,1.12,0,0,0,.46-1.54Zm-6.38.72a.77.77,0,0,1-1-.36.76.76,0,0,1,.36-1,.77.77,0,0,1,1,.36A.76.76,0,0,1,264.94,297.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.32,297.21a1.08,1.08,0,0,0-.74-.54l-6.21-1.23a1.11,1.11,0,0,0-1.28.78l-1.83,6.31a1.1,1.1,0,0,0,.12.88l6.27,10.35a1.11,1.11,0,0,0,1.46.41l8.16-4.22a1.12,1.12,0,0,0,.46-1.54Zm-6.38.72a.77.77,0,0,1-1-.36.76.76,0,0,1,.36-1,.77.77,0,0,1,1,.36A.76.76,0,0,1,264.94,297.93Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.29,306.14a1.8,1.8,0,0,1,.65-2.55,1.7,1.7,0,0,1,2.29,1.07,1.76,1.76,0,0,1-.64,2.56A1.7,1.7,0,0,1,265.29,306.14Zm.78-.37c.36.76.8.91,1.19.72s.59-.66.2-1.47-.84-.89-1.2-.72S265.69,305,266.07,305.77Zm3.78,4.53-1,.48.84-8.91,1-.48Zm1.62-3a1.81,1.81,0,0,1,.65-2.56,1.71,1.71,0,0,1,2.3,1.07,1.77,1.77,0,0,1-.64,2.56A1.71,1.71,0,0,1,271.47,307.34Zm.79-.37c.35.75.79.9,1.18.71s.59-.66.21-1.47-.85-.89-1.21-.72S271.88,306.16,272.26,307Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62,297.44s-4.22-8.1-11.65-3.69",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.69 289.13 152.08 255.86 176.36 253.87 191.26 270.73 171.43 308.56 149.05 311.02 135.69 289.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.05 311.02 167.99 273.08 191.26 270.73 171.43 308.56 149.05 311.02",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.08 255.86 167.99 273.08 191.26 270.73 176.36 253.87 152.08 255.86",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,257.58a1.11,1.11,0,0,0,.86.34l6.32-.32a1.11,1.11,0,0,0,1-1.06l.24-6.57a1.09,1.09,0,0,0-.33-.82l-8.61-8.51a1.11,1.11,0,0,0-1.51,0l-6.89,6.08a1.11,1.11,0,0,0-.06,1.6Zm6-2.25a.75.75,0,1,1,.95,1.17.75.75,0,0,1-.95-1.17Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.22,257.58a1.11,1.11,0,0,0,.86.34l6.32-.32a1.11,1.11,0,0,0,1-1.06l.24-6.57a1.09,1.09,0,0,0-.33-.82l-8.61-8.51a1.11,1.11,0,0,0-1.51,0l-6.89,6.08a1.11,1.11,0,0,0-.06,1.6Zm6-2.25a.75.75,0,1,1,.95,1.17.75.75,0,0,1-.95-1.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,247.45a1.79,1.79,0,0,1,0,2.63,1.7,1.7,0,0,1-2.48-.48,1.77,1.77,0,0,1,0-2.64A1.71,1.71,0,0,1,175.9,247.45Zm-.67.54c-.53-.64-1-.68-1.33-.4s-.4.78.17,1.47,1,.67,1.34.41S175.79,248.68,175.23,248Zm-4.77-3.47.87-.71,1.36,8.84-.87.72Zm-.85,3.27a1.81,1.81,0,0,1,0,2.64,1.71,1.71,0,0,1-2.49-.48,1.77,1.77,0,0,1,0-2.64A1.7,1.7,0,0,1,169.61,247.79Zm-.67.55c-.52-.64-1-.68-1.32-.4s-.41.78.16,1.47,1,.66,1.34.41S169.51,249,168.94,248.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.72,256s5.45,7.33,12.08,1.79",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.45 257.98 212.09 243.87 230.21 252.38 229.4 269.76 200.95 277.92 184.4 272.42 186.45 257.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.4 272.42 211.44 259.92 229.4 269.76 200.95 277.92 184.4 272.42",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.09 243.87 211.44 259.92 229.4 269.76 230.21 252.38 212.09 243.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.08,
    y: 323.35,
    width: 70.1,
    height: 36.46,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.25,
    y: 323.35,
    width: 30.93,
    height: 36.46,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.89,
    y: 298.75,
    width: 58.07,
    height: 25.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.89,
    y: 298.75,
    width: 58.07,
    height: 25.35,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 298.75,
    width: 25.62,
    height: 25.35,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.2,
    y: 274.55,
    width: 48.74,
    height: 25.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.43,
    y: 274.55,
    width: 21.51,
    height: 25.35,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.92 326.58 214.31 293.31 238.59 291.31 253.48 308.18 233.65 346.01 211.27 348.47 197.92 326.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.27 348.47 230.22 310.53 253.48 308.18 233.65 346.01 211.27 348.47",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.31 293.31 230.22 310.53 253.48 308.18 238.59 291.31 214.31 293.31",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,279a1.06,1.06,0,0,0,.52-.76l1.08-6.23a1.1,1.1,0,0,0-.81-1.26l-6.34-1.68a1.09,1.09,0,0,0-.88.14l-10.2,6.52a1.1,1.1,0,0,0-.37,1.46l4.41,8.06a1.1,1.1,0,0,0,1.54.42Zm-.87-6.36a.76.76,0,0,1,.34-1,.75.75,0,0,1,1,.33.76.76,0,0,1-.33,1A.77.77,0,0,1,212.16,272.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,279a1.06,1.06,0,0,0,.52-.76l1.08-6.23a1.1,1.1,0,0,0-.81-1.26l-6.34-1.68a1.09,1.09,0,0,0-.88.14l-10.2,6.52a1.1,1.1,0,0,0-.37,1.46l4.41,8.06a1.1,1.1,0,0,0,1.54.42Zm-.87-6.36a.76.76,0,0,1,.34-1,.75.75,0,0,1,1,.33.76.76,0,0,1-.33,1A.77.77,0,0,1,212.16,272.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,273.17a1.79,1.79,0,0,1,2.56.59,1.7,1.7,0,0,1-1,2.32,1.77,1.77,0,0,1-2.58-.58A1.71,1.71,0,0,1,204,273.17Zm.38.78c-.74.37-.88.81-.69,1.2s.68.57,1.48.17.87-.86.69-1.22S205.14,273.55,204.34,274Zm-4.43,3.88-.51-1,8.93.62.5,1Zm3,1.55a1.81,1.81,0,0,1,2.57.59,1.71,1.71,0,0,1-1,2.32,1.77,1.77,0,0,1-2.58-.58A1.71,1.71,0,0,1,202.91,279.38Zm.39.78c-.74.37-.88.82-.69,1.2s.67.57,1.48.17.87-.86.69-1.22S204.09,279.76,203.3,280.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.48,275.9s-4.21-8.1-11.64-3.69",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.94 297.37 220.29 265.52 235.93 253.87 253.49 260.34 261.14 293.75 248.99 302.45 229.94 297.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.94 297.37 242.99 287.22 261.14 293.75 248.99 302.45 229.94 297.37",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.93 253.87 242.99 287.22 261.14 293.75 253.49 260.34 235.93 253.87",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.97,
    cy: 413.76,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 181.52,
    cy: 413.76,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,410.16H179.88a2.31,2.31,0,0,1,0-4.62h75.31a1.41,1.41,0,0,0,1.41-1.4v-6a1.42,1.42,0,0,0-1.11-1.38l-62.27-13.46a12.24,12.24,0,0,1-9.6-11.91V359.69a2.31,2.31,0,0,1,4.62,0V371.4a7.59,7.59,0,0,0,5.95,7.39l62.28,13.47a6.06,6.06,0,0,1,4.75,5.89v6A6,6,0,0,1,255.19,410.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M255.19,410.16H179.88a2.31,2.31,0,0,1,0-4.62h75.31a1.41,1.41,0,0,0,1.41-1.4v-6a1.42,1.42,0,0,0-1.11-1.38l-62.27-13.46a12.24,12.24,0,0,1-9.6-11.91V359.69a2.31,2.31,0,0,1,4.62,0V371.4a7.59,7.59,0,0,0,5.95,7.39l62.28,13.47a6.06,6.06,0,0,1,4.75,5.89v6A6,6,0,0,1,255.19,410.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,330.55l0-.16,2.69-14.9v0l2.76-15.3a2.31,2.31,0,0,0-2.27-2.72H229a2.31,2.31,0,0,0,0,4.62h8.41l-1.48,10.64H172.65a2.31,2.31,0,1,0,0,4.62h62.62l-1.45,10.39H176.49a2.31,2.31,0,0,0,0,4.62h56.69l-1.5,10.73h-51.5a2.31,2.31,0,1,0,0,4.62H231l-1.35,9.7h-6a2.31,2.31,0,0,0,0,4.62h23.8a2.32,2.32,0,0,0,2.28-1.9l2.57-14.25v0ZM251,327.71h-3.22l1.82-10.39h3.28Zm-.84,4.62-1.94,10.73H245l1.88-10.73Zm3.55-19.63h-3.3l1.87-10.64h3.36Zm-11.59-10.64h5.47l-1.87,10.64h-5.09Zm-2.13,15.26h4.92L243,327.71h-4.55Zm-2.1,15h4.39l-1.89,10.73h-4Zm-2.14,15.35h3.83l-1.7,9.7h-3.48Zm6.82,9.7,1.7-9.7h3.12l-1.76,9.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004,
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255.13,330.55l0-.16,2.69-14.9v0l2.76-15.3a2.31,2.31,0,0,0-2.27-2.72H229a2.31,2.31,0,0,0,0,4.62h8.41l-1.48,10.64H172.65a2.31,2.31,0,1,0,0,4.62h62.62l-1.45,10.39H176.49a2.31,2.31,0,0,0,0,4.62h56.69l-1.5,10.73h-51.5a2.31,2.31,0,1,0,0,4.62H231l-1.35,9.7h-6a2.31,2.31,0,0,0,0,4.62h23.8a2.32,2.32,0,0,0,2.28-1.9l2.57-14.25v0ZM251,327.71h-3.22l1.82-10.39h3.28Zm-.84,4.62-1.94,10.73H245l1.88-10.73Zm3.55-19.63h-3.3l1.87-10.64h3.36Zm-11.59-10.64h5.47l-1.87,10.64h-5.09Zm-2.13,15.26h4.92L243,327.71h-4.55Zm-2.1,15h4.39l-1.89,10.73h-4Zm-2.14,15.35h3.83l-1.7,9.7h-3.48Zm6.82,9.7,1.7-9.7h3.12l-1.76,9.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.69,298.19a2.28,2.28,0,0,0-1.7-.75H135a2.31,2.31,0,0,0-2.25,2.82l3.46,15.22h0l10.18,44.72a2.31,2.31,0,0,0,2.25,1.8h75.08a2.32,2.32,0,0,0,2.3-2.11L231.29,300A2.29,2.29,0,0,0,230.69,298.19Zm-7.84,44.87H212.13l.47-10.72h11.2Zm-59.48,14.32-1.26-9.7h11.54l.7,9.7Zm13.47-29.66-.76-10.4H191.3v10.4Zm14.46,4.62v10.72H178l-.78-10.72Zm4.62-15h12.72l-.46,10.4H195.92Zm0-4.62V302.06h13.4l-.47,10.64Zm-4.62,0H175.75L175,302.06H191.3Zm-20.18,0H157.59l-1.37-10.64h14.13Zm.33,4.62.76,10.4H159.53l-1.34-10.4Zm-16.57,10.4H143.73l-2.37-10.4h12.17Zm-10.1,4.62h10.69l1.39,10.72h-9.64Zm15.35,0h12.41l.78,10.72h-11.8Zm18.15,15.34h13v9.7H179Zm17.64,0H207.3l-.42,9.7h-11Zm0-4.62V332.34H208l-.47,10.72Zm16.89-15.34.46-10.4h11.85l-.91,10.4Zm12.72-15H213.47l.47-10.64h12.53Zm-74-10.64,1.38,10.64H140.31l-2.42-10.64Zm-3.29,45.62h9.19l1.25,9.7h-8.24Zm63.23,9.7.43-9.7h10.52l-.86,9.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.24,410.16H142.93a2.31,2.31,0,1,1,0-4.62h75.31a1.4,1.4,0,0,0,1.4-1.4v-6a1.41,1.41,0,0,0-1.11-1.38l-62.27-13.46a12.25,12.25,0,0,1-9.6-11.91V359.69a2.31,2.31,0,1,1,4.62,0V371.4a7.6,7.6,0,0,0,6,7.39l62.27,13.47a6.06,6.06,0,0,1,4.75,5.89v6A6,6,0,0,1,218.24,410.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.4,
    cy: 413.76,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.21,413.76a3,3,0,1,1-3-3A3,3,0,0,1,220.21,413.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.94,
    cy: 413.76,
    r: 6.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,413.76a3,3,0,1,1-3-3A3,3,0,0,1,140.75,413.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,304.7a1.06,1.06,0,0,0,.31-.86l-.59-6.31a1.09,1.09,0,0,0-1.1-1l-6.57,0a1.08,1.08,0,0,0-.81.36l-8.15,9a1.11,1.11,0,0,0,0,1.51l6.36,6.63a1.12,1.12,0,0,0,1.6,0Zm-2.49-5.91a.75.75,0,1,1,1.12-1,.75.75,0,1,1-1.12,1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.08,304.7a1.06,1.06,0,0,0,.31-.86l-.59-6.31a1.09,1.09,0,0,0-1.1-1l-6.57,0a1.08,1.08,0,0,0-.81.36l-8.15,9a1.11,1.11,0,0,0,0,1.51l6.36,6.63a1.12,1.12,0,0,0,1.6,0Zm-2.49-5.91a.75.75,0,1,1,1.12-1,.75.75,0,1,1-1.12,1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.8,301.45a1.81,1.81,0,0,1,2.64-.1,1.71,1.71,0,0,1-.38,2.5,1.77,1.77,0,0,1-2.64.11A1.71,1.71,0,0,1,126.8,301.45Zm.58.65c-.62.55-.64,1-.35,1.34s.8.37,1.47-.22.61-1.06.35-1.36S128,301.51,127.38,302.1Zm-3.27,4.9-.75-.84,8.78-1.72.75.84Zm3.3.72a1.81,1.81,0,0,1,2.64-.11,1.72,1.72,0,0,1-.38,2.51,1.77,1.77,0,0,1-2.64.11A1.71,1.71,0,0,1,127.41,307.72Zm.58.64c-.62.56-.64,1-.35,1.35s.8.37,1.47-.23.61-1.06.35-1.35S128.65,307.77,128,308.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.33,298.74s-6.18-6.73-12.2-.53",
    style: {
      fill: "none",
      stroke: "#407BFF",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorluulalt);
export default __webpack_public_path__ + "static/media/Borluulalt.fda3b7d5dc8344fc747a121986df460e.svg";
export { ForwardRef as ReactComponent };